import heydoctor from 'app/vendor/heydoctor';
import { sessionStorage } from 'app/lib/storage';
import Settings from 'app/config/settings';
import { Stores, Store } from 'app/lib/synaptik';

const INTENDED_SERVICE_KEY = 'hd.intendedServiceSlug';
export const REQUESTED_DRUG_KEY = 'hd.requestedDrug';

interface State {
  validatingServiceAvailability?: boolean;
  fetchingList?: boolean;
  records: any[];
}

export class ServicesStore extends Store<State, Stores> {
  state: State = {
    fetchingList: false,
    records: [],
  };

  list = () =>
    this.runAsync({
      key: 'fetchingList',
      work: async () => {
        if (this.state.records.length > 0) return this.state.records;

        const services = await heydoctor.services.fetchList();

        const filteredServices = Settings.Services
          ? services.filter((s: any) => Settings.Services.includes(s.slug))
          : services;

        this.setState({
          records: filteredServices,
        });

        return filteredServices;
      },
    });

  validateServiceAvailability = async ({ state }: any) =>
    this.runAsync({
      key: 'validatingServiceAvailability',
      work: async () => {
        if (!state) return false;
        const serviceSlug = this.getIntendedServiceSlug();

        try {
          const { available } = await heydoctor.services.validateServiceAvailability(serviceSlug, state);
          return available;
        } catch (error) {
          return false;
        }
      },
    });

  findBySlug = (slug: string) => {
    return this.state.records.find((s: any) => s.slug === slug);
  };

  isValidSlug = (slug: any) => {
    return !!this.findBySlug(slug);
  };

  getIntendedService = () => {
    const slug = this.getIntendedServiceSlug();
    return this.findBySlug(slug);
  };

  getIntendedServiceSlug = () => sessionStorage.get(INTENDED_SERVICE_KEY);

  updateIntendedService = (slug: any) => {
    sessionStorage.set(INTENDED_SERVICE_KEY, slug);
  };

  deleteIntendedService = () => sessionStorage.remove(INTENDED_SERVICE_KEY);

  getRequestedDrug = () => sessionStorage.get(REQUESTED_DRUG_KEY);

  deleteRequestedDrug = () => sessionStorage.remove(REQUESTED_DRUG_KEY);
}
